(function () {
  'use strict';

  class DTCHeader {
    constructor() {
      this.header = document.querySelector('.dtc-header__wrapper');
      if (!this.header) {
        return;
      }

      this.init();
    }

    init() {
      this.bindEvents();
      this.initStickyHeader();
      this.adjustProductsGridWidth();
      this.initLanguageSwitcher();
      this.adjustSimpleDropdownPosition();
      this.initEmptyStickyInit();
      window.addEventListener('resize', () => {
        this.adjustProductsGridWidth();
        this.adjustSimpleDropdownPosition();
      });
    }

    initEmptyStickyInit() {
      // 为T4SThemeSP.Header创建空的stickyInit方法,避免interactable.min.js不加载时的错误
      if (typeof T4SThemeSP !== 'undefined' && T4SThemeSP.Header && !T4SThemeSP.Header.stickyInit) {
        T4SThemeSP.Header.stickyInit = function () {
          // 空方法,避免错误
        };
      }
    }

    adjustProductsGridWidth() {
      return;
    }

    adjustSimpleDropdownPosition() {
      const simpleDropdowns = this.header.querySelectorAll('.dtc-dropdown--simple');
      const headerWrapper = this.header;
      
      simpleDropdowns.forEach(dropdown => {
        const navItem = dropdown.closest('.dtc-header__nav-item');
        if (!navItem) return;
        
        const navItemRect = navItem.getBoundingClientRect();
        const headerRect = headerWrapper.getBoundingClientRect();
        
        const headerBottom = headerRect.bottom;
        const dropdownTop = headerBottom + 8;
        
        const navItemLeft = navItemRect.left;
        
        dropdown.style.position = 'fixed';
        dropdown.style.top = dropdownTop + 'px';
        dropdown.style.left = navItemLeft + 'px';
        dropdown.style.transform = 'none';
      });
    }

    bindEvents() {
      const dropdownTriggers = this.header.querySelectorAll('[data-dropdown-trigger]');
      const dropdownItems = this.header.querySelectorAll('.has-dropdown');

      dropdownTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.toggleDropdown(e, trigger);
        });
      });

      dropdownItems.forEach(item => {
        let hover_timeout;

        item.addEventListener('mouseenter', () => {
          clearTimeout(hover_timeout);
          const wasActive = item.classList.contains('active');

          if (!wasActive) {
            this.closeAllDropdowns();
          }

          item.classList.add('active');
          this.disableBodyScroll();
          this.adjustProductsGridWidth();
          this.adjustSimpleDropdownPosition();
        });

        item.addEventListener('mouseleave', () => {
          hover_timeout = setTimeout(() => {
            item.classList.remove('active');
            this.enableBodyScroll();
          }, 200);
        });
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.has-dropdown')) {
          this.closeAllDropdowns();
        }
      });
    }

    toggleDropdown(e, trigger) {
      e.preventDefault();
      const parent = trigger.closest('.has-dropdown');
      const isActive = parent.classList.contains('active');

      this.closeAllDropdowns();

      if (!isActive) {
        parent.classList.add('active');
        this.disableBodyScroll();
        this.adjustProductsGridWidth();
        this.adjustSimpleDropdownPosition();
      }
    }

    closeAllDropdowns() {
      const activeDropdowns = this.header.querySelectorAll('.has-dropdown.active');
      activeDropdowns.forEach(dropdown => {
        dropdown.classList.remove('active');
      });
      this.enableBodyScroll();
    }

    disableBodyScroll() {
      const scrollY = window.scrollY;
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.paddingRight = `${scrollbarWidth}px`;
      document.body.classList.add('dropdown-open');
    }

    enableBodyScroll() {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.paddingRight = '';
      document.body.classList.remove('dropdown-open');

      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }

    initStickyHeader() {
      let lastScrollTop = 0;
      const headerHeight = this.header.offsetHeight;

      window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > headerHeight) {
          this.header.classList.add('is-sticky');

          if (scrollTop > lastScrollTop && scrollTop > headerHeight * 2) {
            this.header.classList.add('is-hidden');
          } else {
            this.header.classList.remove('is-hidden');
          }
        } else {
          this.header.classList.remove('is-sticky', 'is-hidden');
        }

        lastScrollTop = scrollTop;
      }, { passive: true });
    }

    initLanguageSwitcher() {
      const languageSwitcher = document.querySelector('[data-language-switcher]');
      if (!languageSwitcher) return;

      const languageItems = languageSwitcher.querySelectorAll('.dtc-language-dropdown__item');

      languageSwitcher.addEventListener('click', (e) => {
        e.stopPropagation();
        languageSwitcher.classList.toggle('is--open');
      });

      languageItems.forEach(item => {
        item.addEventListener('click', (e) => {
          e.stopPropagation();
          const localeIso = item.getAttribute('data-locale-iso');
          if (localeIso) {
            this.switchLanguage(localeIso);
          }
        });
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-language-switcher]')) {
          languageSwitcher.classList.remove('is--open');
        }
      });
    }

    switchLanguage(localeIso) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/localization/update';

      const localeInput = document.createElement('input');
      localeInput.type = 'hidden';
      localeInput.name = 'locale_code';
      localeInput.value = localeIso;

      const returnUrlInput = document.createElement('input');
      returnUrlInput.type = 'hidden';
      returnUrlInput.name = 'return_to';
      returnUrlInput.value = window.location.href;

      form.appendChild(localeInput);
      form.appendChild(returnUrlInput);
      document.body.appendChild(form);
      form.submit();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new DTCHeader();
    });
  } else {
    new DTCHeader();
  }
})();